module.exports = __webpack_public_path__ + "img/cornish_pixies.fb0c4faa.jpg";